let API_URL;

if (process.env.REACT_APP_ENV !== 'PROD') {
    API_URL = 'http://localhost:5000/api/';
} else {
    API_URL = `${document.location.origin}/api/`;
}

export { API_URL };
